import { jsx as _jsx } from "react/jsx-runtime";
import SubscriptionInfoDialog from "../SubscriptionInfoDialog";
import { getSubscriptionBenefitSections } from "./getSubscriptionBenefitSections";
/**
 * 월구독 '이용권 정보 보기' 다이얼로그 (주문결제 페이지).
 *
 * 껍데기는 SubscriptionInfoDialog 가, 섹션 파생은 getSubscriptionBenefitSections 가 담당한다.
 * (구독 관리의 상세정보 다이얼로그가 같은 껍데기를 쓴다 — 이전에는 껍데기가 복제돼 있었다)
 *
 * mixpanel 추적은 기존과 동일하게 없다 — tracking prop 을 넘기지 않는다.
 */ const SubscriptionBenefitDialog = (param)=>/*#__PURE__*/ {
    let { item , onClose  } = param;
    return _jsx(SubscriptionInfoDialog, {
        title: item.title,
        sections: getSubscriptionBenefitSections(item),
        onClose: onClose
    });
};
export default SubscriptionBenefitDialog;
